// Glass Messenger wordmark — chunky, rounded letters in heavy weight
// Plus Jakarta Sans (loaded in index.html). Matches the Pixel/Material-You
// minimalist style requested by the user (reference: "DEVO+" mockup).

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  withText?: boolean;
  className?: string;
}

const SIZE: Record<NonNullable<LogoProps["size"]>, string> = {
  sm: "text-xl",
  md: "text-3xl",
  lg: "text-5xl",
  xl: "text-7xl",
};

export function Logo({ size = "md", withText = true, className = "" }: LogoProps) {
  // withText kept for backward compat; the wordmark itself is the entire logo now.
  void withText;
  return (
    <span
      className={`font-display font-black tracking-tight select-none inline-flex items-baseline ${SIZE[size]} ${className}`}
      style={{ letterSpacing: "-0.05em" }}
    >
      Glass
      <span
        aria-hidden
        className="ml-0.5"
        style={{
          background: "linear-gradient(135deg, #85b8ff 0%, #5594ff 50%, #1551e0 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        +
      </span>
    </span>
  );
}
